<script lang="ts" setup>
import type { FormattedSuggestedSolutionSection } from "~/composables/useMathTaskSolutions"

const { sections = [] } = defineProps<{ sections?: FormattedSuggestedSolutionSection[] }>()
</script>

<template>
  <div
    v-for="(section, index) in sections"
    :key="section.id"
    class="flex flex-col gap-4 [&>*]:font-national2"
    :class="{
      'border-b border-green-dark pb-6 last:border-b-0 last:pb-0 md:pb-10': sections.length > 1,
      'pt-6 md:pt-10': index > 0,
    }"
  >
    <URichText :html="section.sectionBody" />
    <img
      v-if="section?.sectionImage"
      :src="section.sectionImage.src"
      :alt="section.sectionImage.alt"
      class="object-cover"
    />
  </div>
  <div v-if="sections.length === 0">
    Mangler løsningsforlag.
  </div>
</template>
